import React, { useEffect } from 'react'
import { Box, Modal, Backdrop, Fade } from '@material-ui/core'
import { shippingAddressFormStyles } from './shipping-address-form.styles'
import { useShippingAddressForm } from './shipping-address-form.hook'
import { useAddressForm } from '../address-block/address-block.hook'
import { FormHolder } from '../address-block/form-holder'

type ShippingAddressProps = {
  addAddressButtonClicked?: boolean
  setAddAddressButtonClicked?: (value: boolean) => void
  onClose?: () => void
}

export const ShippingAddressForm: React.FC<ShippingAddressProps> = ({
  addAddressButtonClicked,
  setAddAddressButtonClicked,
  onClose,
}) => {
  /* Styles */
  const classes = shippingAddressFormStyles()
  const {
    //props
    addressLoading,
    address,
    fullScreen,
    isOpen,
    regions,
    tempValues,

    //methods
    setIsOpen,
    formValueChangesHandler,
    formValueSaveHandler,
    setRegion,
    loadInitialAddressData,
  } = useAddressForm()

  useEffect(() => {
    loadInitialAddressData()
  }, [])

  // Sync addAddressButtonClicked prop with internal isOpen state
  useEffect(() => {
    if (addAddressButtonClicked) {
      setIsOpen(true)
    }
    if (!addAddressButtonClicked) {
      setIsOpen(false)
    }
  }, [addAddressButtonClicked])

  useEffect(() => {
    if (!isOpen) {
      setAddAddressButtonClicked && setAddAddressButtonClicked(false)
    }
  }, [isOpen])

  const handleClose = () => {
    setIsOpen(false)
    onClose && onClose()
  }

  /*Default Props*/
  return addressLoading ? (
    <></>
  ) : (
    <>
      <Modal
        data-testid="modal"
        data-modal-open={isOpen}
        closeAfterTransition
        open={isOpen}
        onClose={handleClose}
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Fade in={isOpen}>
          <>
            <FormHolder
              address={address}
              fullScreen={fullScreen}
              regions={regions}
              tempValues={tempValues}
              formValueChangesHandler={formValueChangesHandler}
              formValueSaveHandler={formValueSaveHandler}
              setIsOpen={setIsOpen}
              setRegion={setRegion}
            />
          </>
        </Fade>
      </Modal>
    </>
  )
}
